import { AfterViewChecked, Component, ElementRef, HostListener, input, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PwaInstallService } from "pg-lib/pg-ui-elements/pwa-install.service";
import { EFProduct } from "pg-lib/models/experience.model";
import { AuthService } from "pg-lib/services/auth.service";
import { EFDataService } from "pg-lib/services/ef-data.service";
import { EnvironmentDataAppMode, EnvironmentService } from "pg-lib/services/environment.service";
import { NotificationsService } from "pg-lib/services/notifications.service";
import { TotemHomeVariables } from "../../routes/totem-home/totem-home.component";

@Component({
    selector: 'app-totem-home-bottom',
    templateUrl: './totem-home-bottom.component.html',
    styleUrls: ['./totem-home-bottom.component.scss'],
    standalone: false
})
export class TotemHomeBottomComponent implements OnInit, OnDestroy, AfterViewChecked {

    constructor(private router:Router, private route:ActivatedRoute, private environmentService:EnvironmentService, private authService:AuthService, private notificationsService:NotificationsService, private efDataService:EFDataService, private pwaInstallService:PwaInstallService) { }

    @Input() realmId:string;
    @Input() customerCareChannel:string;
    @Input() disableChat:boolean;
    @Input() whatsappChat:string;
    @Input() productsData:Array<EFProduct>;
    @Input() homeVariables:TotemHomeVariables;

    appMode:EnvironmentDataAppMode = null;
    
    chatBooking:string = null;

    chatUnathorizedName = 'Totem'

    isLoading = false;

    ngOnInit(): void {
        this.appMode = this.environmentService.environment.AppMode;

        if(this.appMode == 'web' && this.isChatEnabled()) {
            this.route.fragment.subscribe((fragment) => {
                if(fragment != null) {
                    let _fragmentSplit = fragment.split('/')
                    if(_fragmentSplit[1] == 'booking') {
                        if(_fragmentSplit[2] != null && _fragmentSplit[2] != '') {
                            this.currentContent = 'chat';
                            this.chatBooking = _fragmentSplit[2];
                        }
                    }
                }
            })
        }

        if(this.environmentService.environment.InstallationName != null) {
            this.chatUnathorizedName = this.environmentService.environment.InstallationName;
        }

        this.authService.statusChange.subscribe(() => {
            this.isLoading = true;
            setTimeout(() => {
                this.isLoading = false;
            }, 100)
        })
    }

    isLoggedIn() {
        return this.authService.isLoggedIn()
    }

    logout() {
        this.isLoading = true;
        this.onLoginDismissed()
        this.authService.logout().then(() => {
        })
    }

    ngOnDestroy() {

    }

    isChatEnabled() {
        return !this.disableChat && this.environmentService.isWebsocketEnabled();
    }
    
    canPrint() {
        return this.environmentService.ElectronWrapper != null;
    }

    doPrint() {
        this.environmentService.ElectronWrapper.printContents().then(() => {
            
        })
    }

    currentContent:string = null;

    toggleCurrentContent(id:string) {
        if(this.currentContent == id) this.currentContent = null;
        else this.currentContent = id;
    }

    onLoginDismissed() {
        this.currentContent = null;
    }

    getUnreadNotificationsCount() {
        return this.notificationsService.unreadCount;
    }

    goToCustomerCareBooking() {
        this.router.navigate(['/book-customer-care'])
    }

    isDocked = true;
    private _isDockerTimeout = null;

    ngAfterViewChecked(): void {
        this.onWindowScroll();
    }

    @ViewChild('containerElement') containerElement:ElementRef;

    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {
        clearTimeout(this._isDockerTimeout)
        
        let _isDocked = true;

        if(this.containerElement != null) {
            let _element = this.containerElement.nativeElement as HTMLElement;
       
            let _rect = _element.getBoundingClientRect();
            
            if(_rect.top >= 0 &&
                _rect.left >= 0 &&
                _rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                _rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
                
                _isDocked = false;
            }
        }

        if(this.isDocked != _isDocked) {
            this._isDockerTimeout = setTimeout(() => {
                this.isDocked = _isDocked
            })
        }
    }

    goToWhatsappChat() {
        window.open(this.whatsappChat)
    }

    isSearching = false;

    searchValue:string = null;
    searchResults:Array<EFProduct> = null;

    private _searchValueChangeTimeout = null;

    onSearchValueChange() {
        clearTimeout(this._searchValueChangeTimeout)

        this.isSearching = true;
        this.searchResults = null;

        this._searchValueChangeTimeout = setTimeout(() => {
            this.isSearching = false;

            if(this.searchValue) {
                this.searchResults = this.efDataService.applyTextSearch(this.productsData, this.searchValue)
            }
        }, 250)
    }

    goToProduct(product:EFProduct) {
        this.router.navigate([ '.' ], { relativeTo: this.route, fragment: '/product/' + product.id })
    }

    isDebugEnabled() {
        return this.isLoggedIn() && this.authService.user.superadmin;
    }

    canInstall() {
        return this.pwaInstallService.canInstall()
    }

    doInstall() {
        this.pwaInstallService.doInstall()
    }
}
